module.exports = {"title":"Check-in Application","description":"Please use your phone to scan the QR code.","switch":"Switch Mode","scannedTickets":"Recent scanned tickets","ticketId":"Ticket ID","checkedInDate":"Checked-In Date","note":"Note"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Checkin/locales/en.json
// module id = 1390
// module chunks = 0